<template>
  <div id="app">
    <div class="container" :style="{height: height + 'px'}">
      <transition :name="transitionName">
        <div class="transition-container" :key="curState.id">
          <div class="title-container" v-if="curState.id === 'title'">
            <div class="title-content">
              <div class="title-header">{{curState.text}}</div>
              <div class="title-description">{{curState.description}}</div>
              <button class="title-start-button square-btn" @click="push(curState)">START</button>
            </div>
          </div>

          <div class="result-container" v-else-if="curState.id === 'result'">
            <div class="result-content">
              <div class="result-header">{{curState.text}}</div>
              <div class="result-description">{{curState.description}}</div>
              <button class="result-next-button square-btn" @click="push(curState)">次へ</button>
            </div>
          </div>

          <div class="advice-container" v-else-if="curState.id === 'advice'">
            <div class="advice-content">
              <div class="advice-header">{{curState.text}}</div>
              <div class="advice-description">{{curState.description}}</div>

              <transition name="fade" mode="out-in" @before-enter="$nextTick(() => updateHeight())">
                <div class="form" v-if="!posted" key="form">
                  <div class="form-item">
                    <label class="form-item-label" for="">会社名</label><input v-model="form.companyName" type="text">
                  </div>
                  <div class="form-item">
                    <label class="form-item-label" for="">お名前</label><input v-model="form.name" type="text">
                  </div>
                  <div class="form-item">
                    <label class="form-item-label" for="">メールアドレス</label><input v-model="form.email" type="text">
                  </div>
                  <div class="form-item">
                    <label class="form-item-label" for="">電話番号</label><input v-model="form.tel" type="text">
                  </div>
                  <div class="form-item">
                    <label class="form-item-label" for="">お問い合わせ内容</label><textarea v-model="form.body" rows="3" />
                  </div>
                  <button class="result-next-button square-btn" @click="post">問い合わせをする</button>
                  <div class="form-caution">今回の診断の結果も同時に送信されます</div>
                </div>
                <div class="posted" v-else key="posted">
                    送信しました
                </div>
              </transition>
            </div>
          </div>

          <div class="question-container" v-else>
            <div class="question-header">{{curState.text}}</div>
            <div class="choices-container">
              <div class="choice-wrapper" v-for="choice in curState.choices" :key="choice.id" @click="push(choice)">
                <div
                  class="choice-bg"
                  :style="choice.imageURL?`background-image: url('${choice.imageURL}')`:''"
                >
                  <div
                    class="choice"
                  >
                    <div class="choices-text">
                      {{choice.text}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <footer>
      <div>
        <span class="back" @click="pop">
          Back
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
import yaml from 'js-yaml'
export default {
  name: 'Content',
  data () {
    return {
      data: {},
      curState: {},
      selectHistory: [],
      transitionName: '',
      height: 0,
      posted: false,
      form: {
        companyName: '',
        name: '',
        email: '',
        tel: '',
        body: ''
      }
    }
  },
  created () {
    fetch('./chart.yaml')
      .then(res => {
        return res.text()
      })
      .then(text => {
        this.data = yaml.safeLoad(text)
        this.curState = this.data.title
        history.replaceState({curState: this.curState, selectHistory: this.selectHistory}, '', '#title')
        this.$nextTick(() => {
          this.updateHeight()
        })
      })
    window.onpopstate = event => {
      this.transitionName = 'show-prev'
      const state = event.state
      this.selectHistory = state.selectHistory || []
      this.curState = state.curState
      this.$nextTick(() => {
        this.updateHeight()
      })
    }
  },
  methods: {
    push (choice) {
      this.transitionName = 'show-next'
      if (choice.to === 'questions') {
        this.curState = this.data.questions[1]
        this.curState.id = 1
        history.pushState({curState: this.curState, selectHistory: this.selectHistory}, '', '#1')
      } else if (choice.to === 'result') {
        this.selectHistory.push(
          {
            questionID: location.hash,
            question: this.curState.text,
            choice: choice.text,
            to: choice.to
          }
        )
        this.curState = this.data.results[choice.type]
        this.curState.id = choice.to
        history.pushState({curState: this.curState, selectHistory: this.selectHistory}, '', '#' + choice.to)
      } else if (choice.to === 'advice') {
        this.curState = this.data.advices[choice.type]
        this.curState.id = choice.to
        history.pushState({curState: this.curState, selectHistory: this.selectHistory}, '', '#' + choice.to)
      } else {
        this.selectHistory.push(
          {
            questionID: location.hash,
            question: this.curState.text,
            choice: choice.text,
            to: choice.to
          }
        )
        this.curState = this.data.questions[choice.to]
        this.curState.id = choice.to
        history.pushState({curState: this.curState, selectHistory: this.selectHistory}, '', '#' + choice.to)
      }
      this.$nextTick(() => {
        this.updateHeight()
      })
    },
    pop () {
      this.posted = false
      history.back()
    },
    resetForm () {
      this.form = {
        companyName: '',
        name: '',
        email: '',
        tel: '',
        body: ''
      }
    },
    post () {
      this.form.questions = this.selectHistory
      const body = JSON.stringify(this.form)
      const headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
      fetch(this.data.advices.url, {method: 'POST', headers, body})
        .then(() => {
          this.posted = true
          this.resetForm()
          this.$nextTick(() => {
            this.updateHeight()
          })
        })
        .catch(() => {
          this.posted = true
          this.resetForm()
          this.$nextTick(() => {
            this.updateHeight()
          })
        })
    },
    updateHeight () {
      const dom = document.querySelectorAll('.transition-container')[1]
      if (dom) {
        this.height = dom.clientHeight
        return
      }
      this.height = document.querySelectorAll('.transition-container')[0].clientHeight
    }
  }
}
</script>

<style>
#app {
  padding: 3rem 0;
}

.container{
  padding: 0;
  position: relative;
  transition: all 0.8s;
  transition-delay: 0.3s;
}

.transition-container{
  width: 100vw;
  position: absolute;
}

.title-header, .result-header,
.question-header, .advice-header {
  font-size: 1.6rem;
  font-weight: bold;
  padding: 0 0.4rem;
  margin-bottom: 1.2rem;
}

.title-description {
  padding: 0.4rem;
}

.result-container, .advice-container {
  display: flex;
  justify-content: center;
  padding: 0.4rem;
}

.result-content, .advice-content{
  background-color: #fefefe;
  width: 90%;
  max-width: 600px;
  padding: 12px;
  border: solid 2px black;
  border-radius: 16px;
}

.question-container{
}

.choices-container {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  max-width: 720px;
  width: 80%;
  margin: auto;
}

.choice-wrapper {
  position: relative;
  width: 20%;
  min-width: 120px;
}

.choice-wrapper:before {
  content: "";
  display: block;
  padding-top: 100%;
}

.choice-bg {
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 0.4rem;
  border-radius: 50%;
}

.choice:hover {
  background-color: rgba(236, 151, 112, 0.75);
  border: solid 2px #ec9770;
  transition: all 0.2s;
}

.choice {
  border: solid 2px #133046;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.choices-text{
  font-size: 1.6rem;
}

input {
  width: 60%;
  font-size: 1.3em;
  border-radius: 4px;
}

textarea {
  width: 60%;
  border-radius: 4px;
  -webkit-appearance: textfield;
  background-color: white;
  -webkit-rtl-ordering: logical;
  cursor: text;
  padding: 1px;
  border-width: 2px;
  border-style: inset;
  border-color: initial;
  border-image: initial;
}

.form {
  padding-top: 1rem;
}

.form-item {
  padding-top: 0.2rem;
}

.form-item-label {
  display: inline-block;
  width: 30%;
}

.form-caution {
  font-size: 0.7em;
}

.posted {
  margin-top: 0.4rem;
}

.back {
  cursor: pointer;
}

.square-btn{
  display: inline-block;
  position: relative;
  padding: 0.5em 1.4em;
  margin: 0.4em;
  text-decoration: none;
  background: #ec9770;
  color: #FFF;
  border-bottom: solid 5px #36528c;
  border-right: solid 5px #5375bd;
}

.square-btn:before{
  content: " ";
  position: absolute;
  bottom: -5px;
  left: -1px;
  width: 0;
  height: 0;
  border-width: 0 6px 6px 0px;
  border-style: solid;
  border-color: transparent;
  border-bottom-color: #FFF;
}

.square-btn:after{
  content: " ";
  position: absolute;
  top: -1px;
  right: -5px;
  width: 0;
  height: 0;
  border-width: 0px 6px 6px 0px;
  border-style: solid;
  border-color: #FFF;
  border-bottom-color: transparent;
}

.square-btn:active{
  border:none;
  -ms-transform: translate(6px,6px);
  -webkit-transform: translate(6px,6px);
  transform: translate(6px,6px);
}

.square-btn:active:after,.square_btn:active:before {
  content: none;
}

.show-next-enter-active, .show-next-leave-active,
.show-prev-enter-active, .show-prev-leave-active  {
  transition: all 1.5s ease-in-out;
}
.show-next-enter, .show-prev-leave-to {
  transform: translateX(100%);
}
.show-next-leave-to, .show-prev-enter {
  transform: translateX(-100%);
}

.fade-enter-active, .fade-leave-active {
  transition: all .55s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
